import NewsletterForm from "component/newsletter/NewsletterForm";
import PageContainer from "modules/components/PageContainer";
import styles from "./newsletter-signup.module.scss";

function NewsletterSignup() {
  return (
    <PageContainer ShowGreyOuterContainer>
      <div className={styles.newsletter_signup}>
        <NewsletterForm />
      </div>
    </PageContainer>
  );
}

export default NewsletterSignup;
